import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { SharedModule } from '../shared/shared.module';

import { WindowFactory } from './services/window-factory.service';
import { WindowShellComponent } from './components/window-shell/window-shell.component';
import { WindowCloseDirective } from './directives/window-close.directive';
import { WindowFocusDirective } from './directives/window-focus.directive';
import { ComponentMap } from './interfaces';
import { COMPONENT_REGISTRY, SHELL_DEFAULT_OPTIONS } from './providers';
import { WindowManager } from './services/window-manager.service';

@NgModule({
  declarations: [
    WindowShellComponent,
    WindowCloseDirective,
    WindowFocusDirective,
  ],

  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
  ],

  providers: [
    WindowFactory,
    WindowManager,
    {
      provide: SHELL_DEFAULT_OPTIONS,
      useValue: {
        draggable: true,
        resizable: true,
        initialWidth: '70%',
        initialHeight: '50%',
        minWidth: 300,
        minHeight: 215,
        floating: false,
      },
    }
  ],

  exports: [
    WindowCloseDirective,
    WindowFocusDirective,
  ],

  entryComponents: [WindowShellComponent],
})

export class WindowModule {

  static register(registry: ComponentMap[]): ModuleWithProviders<WindowModule> {

    return {
      ngModule: WindowModule,
      providers: [{
        provide: COMPONENT_REGISTRY,
        useValue: registry,
      }]
    };
  }
}
